export const strings = {
  resetAccountButton: 'Reset',
  resetAccountButtonTooltip:
    'Having technical issues? Try resetting your user account.',
} as const;
